import { Contexts, SchoolRoles, InstitutionRoles, OtherRoles } from './constants'
import { isArray, isObject } from 'lodash'

export const isNurse = user => isValidUser(user) && user.roles.includes(InstitutionRoles.NURSE)

export const isObserver = user => isValidUser(user) && user.roles.includes(InstitutionRoles.OBSERVER)

export const isDomainEvaluator = user => isValidUser(user) && user.roles.includes(SchoolRoles.DOMAIN_EVALUATOR)

export const isSupervisor = user => isValidUser(user) && user.roles.includes(SchoolRoles.SUPERVISOR)

export const isValidator = user => isValidUser(user) && user.roles.includes(SchoolRoles.VALIDATOR)

export const isEncoder = user => isValidUser(user) && user.roles.includes(SchoolRoles.ENCODER)

export const isCoordinator = user => isValidUser(user) && user.roles.includes(SchoolRoles.COORDINATOR)

export const isHospitalAdmin = user => isValidUser(user) && user.roles.includes(InstitutionRoles.HOSPITAL_ADMIN)

export const isInstitutionGroupAdmin = user => isValidUser(user) && user.roles.includes(InstitutionRoles.INSTITUTION_GROUP_ADMIN)

export const isAdmin = user => isValidUser(user) && user.roles.includes(OtherRoles.ADMIN)

export const isStudent = user => isValidUser(user) && user.roles.includes(OtherRoles.STUDENT)

/**
 * Mirrors the backend's ROLE_CREATE_USER (granted through role_hierarchy): coordinator, encoder,
 * hospital admin, group admin and super-admin. The serialized base roles do not contain the expanded
 * hierarchy, so it is rebuilt here. Used in particular to tell apart, on "My profile", the
 * self-service profiles (everything editable but the email) from the admins (email included).
 */
export const canCreateUser = user =>
  isCoordinator(user) || isEncoder(user) || isHospitalAdmin(user) || isInstitutionGroupAdmin(user) || isAdmin(user)

export const isSchoolUser = user => isValidUser(user) && user.context === Contexts.SCHOOL

export const isInstitutionUser = user => isValidUser(user) && user.context === Contexts.INSTITUTION

export const isPremiumUser = user => isValidUser(user) && (
  (isSchoolUser(user) && user.school?.premium) ||
  (isInstitutionUser(user) && user.institutions[0]?.managed)
)

export const isValidUser = user => user && isObject(user) && isArray(user.roles)

export default {
  isNurse,
  isObserver,
  isDomainEvaluator,
  isSupervisor,
  isValidator,
  isEncoder,
  isCoordinator,
  isHospitalAdmin,
  isAdmin,
  isStudent,
  canCreateUser
}
